/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ShuZi.vue?vue&type=template&id=499a61d0&scoped=true&"
import script from "./ShuZi.vue?vue&type=script&lang=js&"
export * from "./ShuZi.vue?vue&type=script&lang=js&"
import style0 from "./ShuZi.vue?vue&type=style&index=0&id=499a61d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a61d0",
  null
  
)

export default component.exports